import { useCallback, useRef } from "react"
import { useDashboardSummaryApi } from "../../infra/dashboard-summary"
import { useAppDispatch, useAppSelector } from "../../presentation/hooks/store-hooks"
import { useUIService } from "../ui"
import { setDashboardSummaryState } from "../../application/states/dashboard-summary"

export const useDashboardSummaryService = () => {
    // Dispatch
    const dispatch = useAppDispatch()
    // State
    const { currentUser } = useAppSelector((state) => state.user)
    // API
    const { getDashboardSummaryDataApi } = useDashboardSummaryApi()
    // UI
    const { setLoading, setAlert } = useUIService()

    // Evita múltiplas chamadas
    const isLoadingRef = useRef(false)

    const getDashboardSummaryData = useCallback(async () => {
        if (!currentUser || isLoadingRef.current) return

        isLoadingRef.current = true
        const loadingId = Math.random().toString()

        try {
            setLoading({
                id: loadingId,
                loading: true,
                message: 'Gerando dashboard...'
            })

            const getDashboardData = await getDashboardSummaryDataApi()

            dispatch(setDashboardSummaryState({
                clientesAtivos: getDashboardData.total.totalSummary.QtdClientes ?? 0,
                // Consumos diários
                consumoIATotalHoje: getDashboardData.daily.dailySummary.QtdConsultasIA ?? 0,
                consumoIDTotalHoje: getDashboardData.daily.dailySummary.QtdConsultasIDVeles ?? 0,
                consumoTotalHoje: getDashboardData.daily.dailySummary.QtdConsultas ?? 0,
                consumoAPITotalHoje: getDashboardData.daily.dailySummary.QtdConsultasAPI ?? 0,
                consumoGeoTOTALHoje: getDashboardData.daily.dailySummary.QtdConsultasGeoVeles ?? 0,
                consumoAutoTOTALHoje: getDashboardData.daily.dailySummary.QtdConsultasAUTO ?? 0,
                consumoScrapyTOTALHoje: getDashboardData.daily.dailySummary.QtdConsultasScrapyVeles ?? 0,

                consumoTotalMensal: getDashboardData.total.totalSummary.QtdConsultas ?? 0,
                consumoIATotalMensal: getDashboardData.total.totalSummary.QtdConsultasIA ?? 0,
                consumoIDTotalMensal: getDashboardData.total.totalSummary.QtdConsultasIDVeles ?? 0,
                consumoAPITotalMensal: getDashboardData.total.totalSummary.QtdConsultasAPI ?? 0,
                consumoGeoTOTALMensal: getDashboardData.total.totalSummary.QtdConsultasGeoVeles ?? 0,
                consumoAutoTOTALMensal: getDashboardData.total.totalSummary.QtdConsultasAUTO ?? 0,
                consumoScrapyTOTALMensal: getDashboardData.total.totalSummary.QtdConsultasScrapyVeles ?? 0,
                usuariosAtivos: getDashboardData.total.totalSummary.QtdUsuarios ?? 0,
                topClientesDaily: getDashboardData.daily.topClientes,
                topUsuariosDaily: getDashboardData.daily.topUsuarios,
                topProdutosDaily: getDashboardData.daily.topProdutos,
                topVariaveisDaily: getDashboardData.daily.topVariaveis,
                topClientesTotal: getDashboardData.total.topClientes,
                topUsuariosTotal: getDashboardData.total.topUsuarios,
                topProdutosTotal: getDashboardData.total.topProdutos,
                topVariaveisTotal: getDashboardData.total.topVariaveis,
                consultaPorTipoConsumo_1: getDashboardData.daily.consultaPorTipoConsumo_1,
                consultaPorTipoConsumo_2: getDashboardData.daily.consultaPorTipoConsumo_2,
                consultaPorTipoConsumo_3: getDashboardData.daily.consultaPorTipoConsumo_3,
                consultaPorTipoConsumo_4: getDashboardData.daily.consultaPorTipoConsumo_4,
                consultaPorTipoConsumo_5: getDashboardData.daily.consultaPorTipoConsumo_5,
                consultaPorTipoConsumo_6: getDashboardData.daily.consultaPorTipoConsumo_6,
                consultaPorTipoConsumo_7: getDashboardData.daily.consultaPorTipoConsumo_7,
                consultaPorTipoConsumo_8: getDashboardData.daily.consultaPorTipoConsumo_8,
                consultaPorTipoConsumo_9: getDashboardData.daily.consultaPorTipoConsumo_9,
                consultaPorTipoConsumo_Outros: getDashboardData.daily.consultaPorTipoConsumo_Outros,
                consultaPorUsuario_1: getDashboardData.total.consultaPorUsuario_1,
                consultaPorUsuario_2: getDashboardData.total.consultaPorUsuario_2,
                consultaPorUsuario_3: getDashboardData.total.consultaPorUsuario_3,
                consultaPorUsuario_4: getDashboardData.total.consultaPorUsuario_4,
                consultaPorUsuario_5: getDashboardData.total.consultaPorUsuario_5,
                consultaPorUsuario_6: getDashboardData.total.consultaPorUsuario_6,
                consultaPorUsuario_7: getDashboardData.total.consultaPorUsuario_7,
                consultaPorUsuario_8: getDashboardData.total.consultaPorUsuario_8,
                consultaPorUsuario_9: getDashboardData.total.consultaPorUsuario_9,
                consultaPorUsuario_Outros: getDashboardData.total.consultaPorUsuario_Outros
            }))

        } catch (error: any) {
            setAlert({
                message: error.response.data.error,
                type: 'error'
            })
        } finally {
            setLoading({
                id: loadingId,
                loading: false
            })
            isLoadingRef.current = false
        }
    }, [currentUser, dispatch, getDashboardSummaryDataApi, setAlert, setLoading])

    return {
        getDashboardSummaryData
    }
}